import React, { useEffect, useState } from 'react';
import TextField from '@material-ui/core/TextField';

export const BlurTextField = React.forwardRef(function BlurTextField({ value, ...props }, ref) {
  const [internalValue, setInternalValue] = useState(value);
  useEffect(() => {
    setInternalValue(value);
  }, [value]);
  return (
    <TextField
      value={internalValue || ''}
      onChange={(evt) => setInternalValue(evt.target.value)}
      {...props}
      ref={ref}
    />
  );
});

BlurTextField.propTypes = TextField.propTypes;

export default BlurTextField;
